import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../components/Button';
import Card from '../components/Card';
import '../styles/pages.css';

/**
 * Página mostrada cuando un usuario intenta acceder a una ruta no autorizada
 */
const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <div className="unauthorized-container">
      <Card title="Acceso Denegado" shadow>
        <div className="unauthorized-content">
          <p>No tienes permisos para acceder a esta página.</p>
          <div className="unauthorized-actions">
            <Button onClick={() => navigate(-1)}>
              Volver
            </Button>
            <Button variant="secondary" onClick={() => navigate('/')}>
              Ir al inicio
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default Unauthorized;
